export default __webpack_public_path__ + "static/media/vendor-dashboard.cfdbab6f.png";